import api from "./api";
import commonApi from "../common/api";
import log from "loglevel";

const state = {
  // StarContentsList
  starContentsList: [],
  startWallId: "",
  targetWallId: ""
};

// getters
const getters = {};

// actions
const actions = {
  async uploadDraftWallThumbnailImage(context, params) {
    try {
      const res = await api.postDraftBookshelfThumbnailImages();

      await commonApi.postS3Image(res.data.signedUrl, params.image);

      const res2 = await api.postDraftBookshelfThumbnailImagesComplete({
        draftWallThumbnailImageId: res.data.draftWallThumbnailImageId
      });

      return {
        status: res.status,
        draftWallThumbnailImageId: res.data.draftWallThumbnailImageId,
        draftWallThumbnailImageUrl: res2.data.imageUrl
      };
    } catch (error) {
      log.error("saveSettingsChanges error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async saveSettingsChanges(context, params) {
    try {
      const res = await api.putPublicationSettings(params);
      return res.status;
    } catch (error) {
      log.error("saveSettingsChanges error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async showPlaceableContentsList(context, params) {
    try {
      const apiParam = {
        type: params.type,
        size: params.size
      };
      let res;
      if (params.target === "starred") {
        res = await api.getPlaceableStarredContentsList(apiParam);
      } else {
        res = await api.getPlaceableOwnContentsList(apiParam);
      }
      return {
        status: res.status,
        placeableContentsList: res.data.placeableContentsList
      };
    } catch (error) {
      log.error("showPlaceableContentsList error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async putContentsOnWall(context, params) {
    try {
      const res = await api.putContentsOnWall(params);
      context.commit("updateIsOnWall", {
        identificationCode: params.identificationCode,
        isOnWall: true
      });
      return res.status;
    } catch (error) {
      log.error("putContentsOnWall error:", error);
      context.commit("common/setError", error, { root: true });
      return error;
    }
  },
  async deleteContentsOnWall(context, params) {
    try {
      const res = await api.deleteContentsOnWall({
        positionIndex: params.positionIndex
      });
      context.commit("updateIsOnWall", {
        identificationCode: "",
        isOnWall: false
      });
      return res.status;
    } catch (error) {
      log.error("deleteContentsOnWall error:", error);
      context.commit("common/setError", error, { root: true });
      return error;
    }
  },
  async setStartWall(context, isOk) {
    if (isOk) {
      // OK
      // console.log("setStartWall = " + state.targetWallId);
      try {
        await api.setStartWallId({
          startWallId: state.targetWallId
        });

        // 設定したstartWallID をコミットしておく
        context.commit("setStartWallId", state.targetWallId);
      } catch (error) {
        log.error("setStartWall error:", error);
        context.commit("common/setError", error, { root: true });
      }
    } else {
      // Cancel
    }
  }
};

//mutations
const mutations = {
  updateIsOnWall(state, { identificationCode, isOnWall }) {
    state.starContentsList = state.starContentsList.map(starContents => {
      return starContents.identificationCode === identificationCode
        ? { ...starContents, isOnWall: isOnWall }
        : starContents;
    });
  },
  setStartWallId(state, startWallId) {
    state.startWallId = startWallId;
  },
  setTargetWallId(state, targetWallId) {
    state.targetWallId = targetWallId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
